<template>
  <div class="bootcmap-materials-overview">
    <p class="bootcmap-materials-overview__description" v-html="overview"></p>
  </div>
</template>

<script>
export default {
  name: 'Overview',
  props: {
    overview: {
      type: String,
      required: true,
    },
  },
}
</script>

<style lang="scss">
.bootcmap-materials-overview {
  &__description {
    font-size: rem(16px);
    color: var(--white);
  }
  &__subtitle {
    font-size: rem(18px);
    color: var(--orange);
    text-transform: uppercase;
    margin: 25px 0;
  }
  &__objectives {
    @include tablet {
      display: grid;
      grid-template-columns: 1fr 1fr;
      grid-template-rows: 1fr;
    }
  }
  &__objective {
    font-size: rem(16px);
    color: var(--white);
    display: flex;
    &--icon {
      margin: 0 8px 0 0;
      color: var(--green);
    }
  }
  &__skill-list {
    margin: 0;
    padding: 0 0 0 20px;
  }
  &__skill {
    font-size: rem(16px);
    color: var(--white);
  }
}
</style>
